import React, { useEffect, useState } from "react";
import { useProductData } from "@/zustand/productStore";
import axios from "axios";
import HTMLReactParser from "html-react-parser";
import Reach from "@/public/fallbacks/reach.svg";

const withReach = ({ type, environment }) => {
  const [reach, setReach] = useState();
  const { country_code } = useProductData();
  const merchantId = window.general_settings?.merchant_id;
  const reachBase = `https://checkout.rch.io/v2.22/badge?MerchantId=${merchantId}&Locale=${country_code?.toUpperCase()}`;

  useEffect(() => {
    if (merchantId) {
      axios
        .get(reachBase)
        .then((response) => {
          const data = response.data;
          setReach(data);
          if (data.result === "ERROR") {
            console.log(data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  useEffect(() => {
    const links = document.getElementsByClassName("reach--inline-link");
    links &&
      Array.from(links).forEach((item) => {
        item.setAttribute("href", "/legal/reach");
      });
  }, [reach?.Html]);

  switch (environment) {
    case "global":
      return (
        <section className="withReach withReach--global">
          <div className="withReach__wrapper">
            {Reach && (
              <img
                className="withReach__icon"
                width="30"
                height="36"
                src={Reach}
                alt={`${general_settings.brand_name} Reach Verified`}
              />
            )}
            <div className="withReach__seperator"></div>
            <article className="withReach__text">{reach?.Text && HTMLReactParser(reach?.Html)}</article>
          </div>
        </section>
      );
    default:
      return (
        <section
          className={`${type == "accordion" ? "withReach--accordion" : "withReach--classic"} withReach`}
          style={environment == "local" && type != "accordion" ? { marginBottom: "16px" } : {}}
        >
          <div className="withReach__wrapper">
            <img
              className="withReach__icon"
              width="30"
              height="36"
              src={Reach}
              alt={`${general_settings?.brand_name} Reach Verified`}
            />
            <div className="withReach__seperator"></div>
            <article className="withReach__text">{reach?.Text && HTMLReactParser(reach?.Html)}</article>
          </div>
        </section>
      );
  }
};

export default withReach;
